module.exports = __webpack_public_path__ + "static/media/20180522-LCS-005-3.d97616c7.jpg";